/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferSystemRequest } from '../../models/offer-system-request';

export interface AddSystemToOffer$Params {
  offerId: number;
      body: OfferSystemRequest
}

export function addSystemToOffer(http: HttpClient, rootUrl: string, params: AddSystemToOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addSystemToOffer.PATH, 'post');
  if (params) {
    rb.path('offerId', params.offerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addSystemToOffer.PATH = '/offer/{offerId}/system';
